module.exports = __webpack_public_path__ + "static/media/storm-tech.9d076770.png";